export default {
  /** 分页销售订单列表查询 */
  query: '/api/sales/order_query/search',
  updateRemark: '/api/sales/order/update_remark',
  /** 打印面单 */
  print: '/api/sales/order/print_waybill',
}
